import { useEffect, useRef } from "react";
import type { CSSProperties } from "react";
import { StarIcon } from "./StarIcon";

const DURATION_MS = 1600;

/**
 * The moment a reviewed day earns its star: a full-screen wash of the kid's colour with a star
 * streaking across it, then gone. CSS keyframes only (styles.css), so it costs no dependency;
 * with reduced motion the star simply sits still for the same time. Tapping dismisses it early.
 */
export function ShootingStar({ onDone, text = "Star earned!" }: { onDone: () => void; text?: string }) {
  // Held in a ref so a parent re-render does not restart the clock.
  const done = useRef(onDone);
  done.current = onDone;

  useEffect(() => {
    const t = window.setTimeout(() => done.current(), DURATION_MS);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div
      className="shooting-star"
      role="status"
      style={{ "--shoot-ms": `${DURATION_MS}ms` } as CSSProperties}
      onClick={() => done.current()}
    >
      <span className="shooting-star__flyer" aria-hidden="true">
        <span className="shooting-star__trail" />
        <StarIcon className="shooting-star__star" />
      </span>
      <span className="shooting-star__still" aria-hidden="true">
        <StarIcon className="shooting-star__star" />
      </span>
      <p className="shooting-star__text">{text}</p>
    </div>
  );
}
